import { Button, SimpleCallback, SimpleText } from 'platform-components';
import React from 'react';

interface Props {
    disabled?: boolean;
    onOpenButtonClick: SimpleCallback;
}

const CertificateCardButtonOpen = (props: Props) => {
    const { onOpenButtonClick, disabled = false } = props;

    return (
        <Button
            className="certificate-card__button"
            disabled={disabled}
            onClick={onOpenButtonClick}
            view={Button.VIEW.PSEUDO}
        >
            <SimpleText id="teacherLK.card.buttonText.open" />
        </Button>
    );
};

export default CertificateCardButtonOpen;
